import { createSelector } from 'reselect';

import {
  GET_IMPORT_DATA_CLIENT_SUCCESS,
  GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS,
  GET_IMPORT_DATA_ALL_SUCCESS,
  GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS,
  GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS,
} from '../../actions/trt';
import trtStatistics from '../../utils/trtStatistics';

const initialState = {
  users: {},
  clients: {},
  clientsForSubscriptionInfo: {},
};

export default function trtReducer(state = initialState, action) {
  switch (action.type) {
    case GET_IMPORT_DATA_CLIENT_SUCCESS:
    case GET_IMPORT_DATA_CLIENT_WITH_TIME_PERIOD_SUCCESS: {
      const users = action.payload.data;
      return {
        ...state,
        users,
      };
    }
    case GET_IMPORT_DATA_ALL_SUCCESS:
    case GET_IMPORT_DATA_ALL_WITH_TIME_PERIOD_SUCCESS: {
      const clients = action.payload.data;
      return {
        ...state,
        clients,
      }
    }
    case GET_IMPORT_DATA_FOR_SUBSCRIPTION_INFO_SUCCESS: {
      const clientsForSubscriptionInfo = action.payload.data;
      return {
        ...state,
        clientsForSubscriptionInfo,
      }
    }
    default:
      return state;
  }
}
const getUsers = state => state.trt.users;
const getClients = state => state.trt.clients;

export const usersExcelSelector = createSelector(
  [getUsers],
  users =>
    trtStatistics.getUsersExcelStatistics(users)
);

export const clientsExcelSelector = createSelector(
    [getClients],
    clients =>
        trtStatistics.getClientsExcelStatistics(clients)
);
